<template>
  <div class="main-wrapper">
    <HeaderComponent v-if="$route.meta.HeaderComponent" />
    <SidebarComponent v-if="$route.meta.SidebarComponent" />
    <SidebarAppComponent v-if="$route.meta.SidebarAppComponent" />
    <SidebarMTAdmin v-if="$route.meta.SidebarMTAdmin" />
    <router-view />
  </div>
</template>

<script>
// Import các component con bạn sẽ tạo
import HeaderComponent from "./components/HeaderComponent.vue";
import SidebarComponent from "./components/SidebarComponent.vue";
import SidebarAppComponent from "./components/SidebarAppComponent.vue";
import SidebarMTAdmin from "./components/SidebarMTAdmin.vue";
import RBAC from "./api/rbac";
import userService from "@/services/userService";

export default {
  name: "App",
  components: {
    HeaderComponent,
    SidebarComponent,
    SidebarAppComponent,
    SidebarMTAdmin,
  },

  async mounted() {
    const refreshToken = localStorage.getItem("refreshToken");
    const token = localStorage.getItem("accessToken");
    if (refreshToken || token) {
      // try {
      //   const getMe = await userService.getMe();
      //   localStorage.setItem("avatarUrl", getMe.data.data.content[0].avatarUrl);
      // } catch (error) {}
      try {
      const pushStore = usePushStore();

      // Load trạng thái hiện tại của trình duyệt
      await pushStore.checkSubscriptionStatus();

      // Điều kiện auto-subscribe:
      // - Browser hỗ trợ push
      // - Chưa subscribed
      // - Không đang xử lý
      // - Không phải trường hợp user từng block
      if (
        pushStore.isPushEnabled &&
        !pushStore.isSubscribed &&
        !pushStore.isLoading
      ) {
        await pushStore.toggleSubscription();
      }
    } catch (e) {
      console.warn("Auto realtime init error:", e);
    }
      await RBAC.loadMe();
    }
    // else {
    //   localStorage.removeItem("avatarUrl");
    // }
  },
};
</script>

<style>
/* Các style toàn cục hoặc style cho #app */
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: "Plus Jakarta Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* Đảm bảo không có margin-top hoặc padding nào làm hỏng layout tổng */
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Plus Jakarta Sans", sans-serif;
  margin-top: 0;
  font-weight: 700 !important;
}
/* Bạn có thể thêm các style toàn cục từ style.css hoặc các style điều chỉnh layout tổng thể ở đây */
</style>
